import { api } from "api";

/**
 * POST /api/menu-extraction/extract — multipart with vendorId + N images.
 * Returns { vendorId, model, images: [{ filename, items, notes, error }] }.
 */
export const extractMenu = async (formData, options = {}) => {
    const response = await api.post("api/menu-extraction/extract", formData, {
        // 5-minute ceiling — DOAP HTTP timeout. Sync flow blocks on AI inference.
        timeout: 5 * 60 * 1000,
        ...options,
    });
    return response.data;
};

/**
 * POST /api/menu-extraction/commit — JSON body with vendorId + items.
 * Returns { committedCount }.
 */
export const commitMenu = async (payload) => {
    const response = await api.post("api/menu-extraction/commit", payload);
    return response.data;
};
